import { style } from "@vanilla-extract/css";
import { theme } from "../../theme/css/theme.css";

export const tableStyle = style({
  margin: `${theme.spacings.xxs2} 0`,
});
